module.exports = __webpack_public_path__ + "static/media/sfax.090cf080.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/carousel/sfax.jpg
 ** module id = 423
 ** module chunks = 0
 **/